<template>
  <div class="home">
    <nav class="navbar">
      <div class="navbar__left">
        <img
            alt="logo"
            src="../assets/logo_quick_pay_2022.png"
            style="margin: 0 auto"
        />
      </div>
      <div class="navbar__center">
        <ul>
          <li class="active" @click="changePage('/comercial')">Datos Comerciales</li>
          <li @click="changePage('/Incidencias')">Incidencias</li>
          <li @click="changePage('/InboxSugerences')">Buzón de sugerencias</li>
          <li  @click="changePage('/ClientesB2B')">Clientes</li>
          <li  @click="changePage('/UsuariosB2B')">Usuarios</li>
          <li @click="changePage('/Indicators/productos')">Indicadores</li>
          <li @click="changePage('/CargaArchivos')">Conciliación</li>
        </ul>
      </div>
      <div class="navbar__right">
        <div class="profile">
          <div class="profile__icon">
            <i class="far fa-user-circle"></i>
          </div>
          <div class="profile__detail">
            <p>{{usuario}}</p>
            <span>{{fecha}}</span>
          </div>
          <div @click="handleClick" class="profile__logout">
            <i class="fas fa-sign-out-alt"></i>
          </div>
        </div>
      </div>
    </nav>
    <div class="body">
      <div class="body__sidebar" id="body__sidebar">
        <div class="back_company" @click="backCompany" style="cursor: pointer;">
          <p> <i class="fas fa-chevron-left"></i> Regresar</p>
        </div>
        <hidden-arrow></hidden-arrow>
        <div class="title">
          <div class="title__icon">
            <i class="fas fa-home"></i>
          </div>
          <div class="title__text">
            <h2>Menu QuickPay</h2>
            <p>Selecciona una opción</p>
          </div>
        </div>
        <div class="tabs">
          <router-link :to="{ path: '/branchoffice', query: { id: this.id }}" class="tab ">
            <div class="tab__icon">
              <i class="fas fa-globe"></i>
            </div>
            <div class="tab__text">
              <p>Sucursales</p>
            </div>
          </router-link>
          <router-link :to="{ path: '/ProductsAdmin', query: { id: this.id }}" class="tab active">
            <div class="tab__icon">
              <i class="fas fa-shopping-bag"></i>
            </div>
            <div class="tab__text">
              <p>Productos</p>
            </div>
          </router-link>
          <router-link :to="{ path: '/DiscountAdmin', query: { id: this.id }}" class="tab">
            <div class="tab__icon">
              <i class="fas fa-percentage"></i>
            </div>
            <div class="tab__text">
              <p>Descuentos</p>
            </div>
          </router-link>
          <router-link :to="{ path: '/IncidenciaAdmin', query: { id: this.id }}" class="tab">
            <div class="tab__icon">
              <i class="far fa-chart-bar"></i>
            </div>
            <div class="tab__text">
              <p>Incidencia</p>
            </div>
          </router-link>
        </div>
      </div>
      <div class="body__containt">
        <div class="page__title">
          <open-arrow></open-arrow>
          <h2>Productos</h2>
        </div>
        <div class="page__filters">
          <input type="text" placeholder="Código de Productos" v-model="product_code" @keyup="search"/>
          <input type="text" placeholder="Nombre del Producto"  v-model="nombre_producto" @keyup="search"/>
          <select v-model="product_brand" @change="search">
            <option selected="selected" value="">Marca</option>
            <option v-for="valor of brand" :key="valor.id" :value="valor.id">{{ valor.name}}</option>
          </select>
          <select v-model="product_image" @change="search">
            <option selected="selected" value="">Imagen precargada</option>
            <option value="1">Si</option>
            <option value="0">No</option>
          </select>
        </div>
        <div class="page__buttons"  style="margin-top: 2rem;">
          <button @click="createProduct()" class="button">
            Nuevo Producto <i class="fas fa-plus"></i>
          </button>
          <button @click="importProduct()" class="button">
            Carga Masiva <i class="fas fa-upload"></i>
          </button>
          <ButtonExport
              :data="products"
              :columns="columns"
              :sheet-name="'Datos Productos'"
              :file-name="'Reporte Productos'"
          />
        </div>
        <div class="page__table" style="overflow: auto">
          <div class="table-headers">
            <p v-for="{ label } of columns" :key="label">{{ label }}</p>
            <p>Accion</p>
          </div>
          <div class="table-body">
            <div class="data" :key="product.id" v-for="product of products">
              <p >
                {{ codeFormat(product.product_code) }}
              </p>
              <p>{{ product.product_name }}</p>
              <p>{{ product.product_descripcion }}</p>
              <p>{{ product.type }}</p>
              <p>{{ product.brand }}</p>
              <p>
                {{ dateFormat(product.created_at) }}
              </p>
              <p>
                {{ dateFormat(product.updated_at) }}
              </p>
              <p>{{ conditionalFormatValue(product.product_path) }}</p>
              <Dropdown :id="product.id" :type="type"/>
            </div>
            <div style="text-align: center;" v-if="empty">
              <h4 style="color: #938f8f; padding: 50px;">No se encontraron datos</h4>
            </div>
          </div>
        </div>
        <div class="page__pagination">
          <Pagination
              :data="pagination"
              v-on:changePage="handleClickInParent"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Navbar from '@/components/NavBar'
import ButtonExport from '@/components/ButtonExport.vue'
import Pagination from '@/components/Pagination.vue'
import {
  codeFormat,
  dateFormat,
  conditionalFormatValue
} from '@/utils/formats'
import Dropdown from '@/components/Dropdown.vue'
import OpenArrow from '@/components/OpenArrow.vue';
import HiddenArrow from '@/components/HiddenArrow.vue';

export default {
  name: 'ProductsAdmin',
  components: {
    Navbar,
    ButtonExport,
    Pagination,
    Dropdown,
    HiddenArrow,
    OpenArrow
  },
  data() {
    return {
      type: 'productAdmin',
      product_brand: '',
      product_image: '',
      nombre_producto: '',
      id: '',
      product_code: '',
      empty: false,
      brand: '',
      timeout: null,
      products: [],
      pagination: [],
      columns: [
        {
          label: 'Código de productos',
          field: 'product_code',
          dataFormat: this.codeFormat
        },
        { label: 'Nombre de producto', field: 'product_name' },
        { label: 'Descripción', field: 'product_descripcion' },
        { label: 'Tipo de Producto', field: 'type' },
        { label: 'Marca', field: 'brand' },
        {
          label: 'Fecha de Registro',
          field: 'created_at',
          dataFormat: this.dateFormat
        },
        {
          label: 'Fecha de Actualización',
          field: 'updated_at',
          dataFormat: this.dateFormat
        },
        {
          label: 'Imagen Cargada',
          field: 'product_path',
          dataFormat: this.conditionalFormatValue
        }
      ]
    }
  },
  // computed:{
  //   search: function () {
  //     let nombre = this.products.filter((item) => item.product_name.toLowerCase().includes(this.nombre_producto.toLowerCase()));
  //     let marca = nombre.filter((item) => item.product_brand_id.toString().includes(this.product_brand.toString()));
  //     let imagen = marca.filter((item) => item.imagen.toString().includes(this.product_image.toString()));
  //     return imagen.filter((item) => item.product_code.toString().toLowerCase().includes(this.product_code.toLowerCase()));
  //   }
  // },
  methods: {
    backCompany(){
      this.$router.push('/comercial')
    },
    changePage(url) {
      this.$router.push(url)
    },
    handleClickInParent: function(page) {
      this.getall(page)
    },
    zeroFill(number, width) {
        width -= number.toString().length
        if (width > 0) {
          return (
              new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
          )
        }
        return number + ''
      },
    getDate() {
        let dias = [
          'Lunes',
          'Martes',
          'Miercoles',
          'Jueves',
          'Viernes',
          'Sabado',
          'Domingo'
        ]
        let meses = [
          'Enero',
          'Febrero',
          'Marzo',
          'Abril',
          'Mayo',
          'Junio',
          'Julio',
          'Agosto',
          'Septiembre',
          'Octubre',
          'Noviembre',
          'Diciembre'
        ]

        let date = new Date()

        const fechaNum = date.getDate()
        const mes_name = date.getMonth()

        let day = date.getDay() === 0 ? 6 : date.getDay() - 1
        this.fecha = dias[day] + ' ' + this.zeroFill(fechaNum, 2) + ' de ' + meses[mes_name]
      },
    search: function() {
      clearTimeout(this.timeout);
      var self = this;
      this.timeout = setTimeout(function () {
        let paramSearch = {
          product_code: self.product_code,
          nombre_producto: self.nombre_producto,
          marca: self.product_brand,
          imagen: self.product_image,
        }
        this.getall(1, paramSearch)
      }.bind(this), 500);
    },
    codeFormat,
    dateFormat,
    conditionalFormatValue,
    createProduct() {
      this.$router.push({
        path: '/AddProduct',
        query: { id: this.id }
      })
    },
    async getBrand(){
      const params = {
        product_company_id:  localStorage.getItem('company_id')
      }
      await axios.get('general/elements/brand', params).then(res => {
        this.brand = res.data.data
      })
    },
    handleClick() {
      localStorage.removeItem('token')
      this.$router.push('/login')
    },
    async getall(page = 1, paramSearch = {}) {
      await axios.get('general/product', {params: {
          page: page,
          product_company_id: this.id,
          product_code: paramSearch.product_code,
          product_name: (paramSearch.nombre_producto !== '') ? paramSearch.nombre_producto : null,
          product_brand_id: paramSearch.marca,
          imagen: paramSearch.imagen,
        }}).then( res => {
        if (res.data.data.total > 0){
          this.products = res.data.data.data
          this.pagination = res.data.data
          this.empty = false
        }else{
          this.products = {}
          this.pagination = {}
          this.empty = true
        }
      })
    },
    showProduct(id) {
      this.$router.push({ path: '/Client/ShowProduct', query: { id: id } })
    },
    async importProduct() {
      const { value: file } = await this.$swal({
        title: 'IMPORTAR PRODUCTOS',
        html: 'descarga el formato <a href="http://34.125.120.126/files/download/fm_import_product.xlsx">aquí</a>',
        input: 'file',
        inputAttributes: {
          accept: '.xlsx',
          'aria-label': ''
        },
        showCancelButton: true,
        confirmButtonText: 'Importar',
        cancelButtonText: 'Cancelar',
        cancelButtonColor: '#ff3128',
        confirmButtonColor: '#32ba7c',
        showLoaderOnConfirm: true
      })

      if (file) {
        const reader = new FileReader()
        const formData = new FormData();
        formData.append('file', file);
        reader.onload = async e => {
          const response = await axios.post('general/product/import', formData).then(
              res => {
                if (res.data.success){
                  this.$swal({
                    position: 'center',
                    icon: 'success',
                    title: 'Producto importados correctamente',
                    text: res.data.data,
                    showConfirmButton: false,
                    timer: 2000
                  })
                }else {
                  this.$swal({
                    position: 'center',
                    icon: 'error',
                    title: 'Ocurrio un error',
                    showConfirmButton: false,
                    timer: 2000
                  })
                }
              }
          )
        }
        reader.readAsDataURL(file)
      }
    }
  },
  created() {
    const valores = window.location.search;
    const urlParams = new URLSearchParams(valores);
    this.id = urlParams.get('id');
    this.getall()
    this.usuario = localStorage.getItem('usuario');
    this.getDate();
    this.getBrand()
  }
}
</script>

<style scoped>
.back_company {
  background: #000;
  color: white;
  width: 100%;
  padding-top: 3%;
  padding-left: 10%;
}

/*------NAVBAR------*/
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  font-family: 'Readex Pro', sans-serif;
}

.home .navbar {
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #dbdbdb;
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.05);
}

.home .navbar__left {
  width: 200px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.home .navbar__left img {
  width: 130px;
}

.home .navbar__center {
  width: 70%;
  height: 100%;
}

.home .navbar__center ul{
  width: 100%;
  height: 100%;
  display: flex;
  list-style: none;
  display: flex;
  justify-content: flex-start;
}
.home .navbar__center ul li {
  text-decoration: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 10px;
  position: relative;
  cursor: pointer;
}

.home .navbar__center ul li.active {
  color: #ff3128;
}
.home .navbar__center ul li.active::before {
  width: 100%;
}

.home .navbar__center ul li::before {
  content: '';
  position: absolute;
  bottom: 0;
  width: 0;
  height: 4px;
  background-color: #ff3128;
  transition: .3s ease;
}
.home .navbar__center ul li:hover {
  color: #ff3128;
}
.home .navbar__center ul li:hover::before {
  width: 100%;
}

.home .navbar__right {
  display: flex;
}
.home .navbar__right .profile {
  display: flex;
  width: 300px;
  height: 100%;
}

.home .navbar__right .profile__detail{
  width: 220px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5px;
}
.home .navbar__right .profile__detail p {
  margin: 0;
}
.home .navbar__right .profile__detail span {
  color: #938f8f;
  font-weight: 300;

}

.home .navbar__right .profile__icon,
.home .navbar__right .profile__logout {
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 25px;
  color: #ff3128;
  cursor: pointer;
}
/*------NAVBAR------*/

/*-------------------------*/
/*-------------------------*/

/*------BODY------*/

.body {
  width: 100%;
  height: 600px;
  display: flex;

}
.body__sidebar,
.body__containt  {
  height: calc(100vh - 120px);
  box-shadow: 1px 10px 10px rgba(0, 0, 0, 0.1);
}
.body__sidebar {
  width: 400px;
  position: relative;
  display: flex;
  flex-direction: column;
}

.body__sidebar .floating-icon {
  position: absolute;
  right: -15px;
  top: 50px;
  color: #ff3128;
  font-size: 30px;
}

.body__sidebar .title {
  width: 100%;
  height: 140px;
  border-bottom: 1px solid #b6b6b6;
  display: flex;
  align-items: center;
  justify-content: center;
}
.body__sidebar .title__icon {
  color: #ff3128;
  font-size: 20px;
}
.body__sidebar .title__text {
  margin: 0 10px;

}

.body__sidebar .title__text h2 {
  font-size: 20px;
  margin: 0;
}
.body__sidebar .title__text p {
  margin: 0;
  font-weight: 300;
}

.body__sidebar .tabs {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 140px);
  padding-top: 5px;
}

.body__sidebar .tabs .tab {
  width: 90%;
  height: 70px;
  border-radius: 10px;
  color: #707070;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.3 ease;
}
.body__sidebar .tabs .tab:hover,
.body__sidebar .tabs .tab.active {
  color: #ff3128;
  background: #ffeeed;
}

.body__sidebar .tabs .tab__icon {
  font-size: 20px;
  margin-right: 10px;
}

.body__sidebar .tabs .tab__text p{
  margin: 0;
  font-weight: 600;
}

.body__containt {
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
}

.body__containt .page__title {
  width: 100%;
  margin-bottom: 20px;
}

.body__containt .page__title h2 {
  font-weight: 600;
  color: #ff3128;
  font-size: 25px;
}

.body__containt .page__filters {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
}
.body__containt .page__filters input {
  border-radius: 10px;
  border: 1px solid #e4e4e4;
  background: #fff;
  padding: 15px 20px;
  /* margin: 0 10px; */
}

.body__containt .page__buttons {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 20px;
}

.body__containt .page__buttons .button {
  width: 250px;
  padding: 15px 20px;
  border-radius: 15px;
  font-size: 17px;
  color: #fff;
  border: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.body__containt .page__buttons .button:nth-child(1) {
  background: #32ba7c;
}
.body__containt .page__buttons .button:nth-child(2) {
  background: #ff3128;
}
.body__containt .page__buttons .button:nth-child(3) {
  background: #262626;
}

.body__containt .page__table {
  width: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  margin-top: 50px;
}

.body__containt .page__table .table-headers {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #b6b6b6;
}
.body__containt .page__table .table-headers p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
}

.body__containt .page__table .table-body {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #b6b6b6;
}

.body__containt .page__table .table-body .data {
  width: 100%;
  display: flex;
}
.body__containt .page__table .table-body .data p {
  width: calc(100% / 7);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 300;
  margin: 10px 0;
}
.body__containt .page__table .table-body .data p:nth-child(1) {
  color: #ff3128;
}
/* .body__containt .page__filters input:nth-child(1) {
  width: 300px;
  margin: 0;
  margin-right: 10px;
} */


/*------BODY------*/
.body__sidebar.open{
  display: none;
}

  .body__containt .page__filters input,
  select {
    border-radius: 10px;
    border: 1px solid #e4e4e4;
    background: #fff;
    padding: 15px 20px;
    /* margin: 0 10px; */
  }
</style>
